module.exports = __webpack_public_path__ + "img/zhonglin.a0fab8a6.jpg";